import { api } from 'services/companiesApi';

export const getRisks = async () => {
	return await api.get('/job-risks');
};

export const getJobProfile = async (id: string) => {
	return await api.get(`/job-profiles/${id}`);
};

export const putJobProfile = async (id: string, data: any) => {
	return await api.put(`/job-profiles/${id}`, data);
};

export const postJobProfile = async (data: any) => {
	return await api.post('/job-profiles', data);
};
